import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fullName: "",
  phoneNumber: "",
  emailAddress: "",
  isSubmitted: false,
  leadId: 0,
};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    populateStateWithUserDetails: (state, action) => {
      state.fullName = action.payload.fullName;
      state.phoneNumber = action.payload.phoneNumber;
      state.emailAddress = action.payload.emailAddress;
      state.leadId = action.payload.leadId;

      sessionStorage.setItem("fullName", action.payload.fullName);
      sessionStorage.setItem("phoneNumber", action.payload.phoneNumber);
      sessionStorage.setItem("emailAddress", action.payload.emailAddress);
    },
    updateLeadId: (state, action) => {
      state.leadId = action.payload.leadId;
    },
    updateSubmissionStatus: (state, action) => {
      state.isSubmitted = action.payload;
    },
    updateUserPhone: (state, action) => {
      state.phoneNumber = action.payload.phoneNumber;
    },
  },
});

export const {
  populateStateWithUserDetails,
  updateSubmissionStatus,
  updateLeadId,
  updateUserPhone,
} = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
